/* @flow */

export const SELECAO_PRECO_MAIOR = 'maior';
export const SELECAO_PRECO_SOMAR = 'somar';
